module.exports = __webpack_public_path__ + "img/52.02863bf3.png";